import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import memoize from 'memoize-one';
import { LS_PROVIDER_KEY, PROVIDERS_API } from './constants';
/**
 * Check if the url is supported by Linking Platform by
 * testing it against any of the regex patterns
 * @param url string
 * @returns boolean
 */
export var isSupportedByLinkingPlatform = function isSupportedByLinkingPlatform(url, regexStorage) {
  var cachedProviderRegex = getProviderRegexFromLs(regexStorage);
  if (!cachedProviderRegex.length || !url.length) {
    return false;
  }
  var regexPattern = new RegExp(cachedProviderRegex, 'g');
  return regexPattern.test(url);
};

/**
 * Get the currently stored provider regex patterns from LS
 * @returns Json<ProviderRegexStorage>
 */
export var getProviderRegexFromLs = function getProviderRegexFromLs(regexStorage) {
  if (regexStorage.getItem(LS_PROVIDER_KEY)) {
    return JSON.parse("".concat(regexStorage.getItem(LS_PROVIDER_KEY)));
  }
  return '';
};

/**
 * setProviderRegexLs - set the provider regex patterns in Storage for
 * easy access within the synchronous md tokenizers
 * @param providerRegex string - combined regex patterns from Linking Platform to identify supported urls
 */
export var setProviderRegexLs = function setProviderRegexLs(regexStorage, providerRegex) {
  regexStorage === null || regexStorage === void 0 || regexStorage.setItem(LS_PROVIDER_KEY, JSON.stringify(providerRegex));
};

/**
 * hydrateLinkingPlatformCache - fetch the provider regex patterns from Linking Platform
 */
export var hydrateLinkingPlatformCache = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(regexStorage, baseUrl) {
    var providerRegex;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return getProviderRegexFromLinkingPlatform(baseUrl);
        case 2:
          providerRegex = _context.sent;
          setProviderRegexLs(regexStorage, providerRegex);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function hydrateLinkingPlatformCache(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * reduceProviderRegex
 * @param data - ProviderRegexResponse
 * @returns string - combined regex patterns from Linking Platform for a single regex test
 * to avoid individual tests on a loop of the providers
 */
export var reduceProviderRegex = function reduceProviderRegex(data) {
  var sources = data.providers.reduce(function (acc, provider) {
    var providerSources = provider.patterns.map(function (pattern) {
      return pattern.source;
    });
    return [].concat(_toConsumableArray(acc), _toConsumableArray(providerSources));
  }, []);
  return sources.join('|');
};

/**
 * Get a list of regex patterns for all supported providers from Linking Platform
 * This is called to hydrate localStorage with every `ContentRenderer` mount, so we're
 * memoizing the response to avoid unnecessary network requests
 * @returns ProviderRegexStorage
 */
export var getProviderRegexFromLinkingPlatform = memoize( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
  var baseUrl,
    response,
    data,
    _args2 = arguments;
  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        baseUrl = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : '';
        _context2.prev = 1;
        _context2.next = 4;
        return fetch(baseUrl + PROVIDERS_API, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            type: 'resolve'
          })
        });
      case 4:
        response = _context2.sent;
        _context2.next = 7;
        return response.json();
      case 7:
        data = _context2.sent;
        return _context2.abrupt("return", !data ? '' : reduceProviderRegex(data));
      case 11:
        _context2.prev = 11;
        _context2.t0 = _context2["catch"](1);
        return _context2.abrupt("return", '');
      case 14:
      case "end":
        return _context2.stop();
    }
  }, _callee2, null, [[1, 11]]);
})));